var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DocUpload',{attrs:{"document":_vm.document,"uploaded-file-name":_vm.getUploadedFilename,"is-upload-in-progress":_vm.isUploadInProgress},on:{"file-selected":_vm.onFileSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }